import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import AddCategory from "./AddCategory";
import EditCategory from "./EditCategory";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const categoryListEndpoint = ApiEndpoints.Dynamiccategory.categoryList;
const categoryDeleteEndpoint = ApiEndpoints.Dynamiccategory.categoryDelete;

const tableHeader = ["Date", "Name", "status"];
const tbody = ["createdAt", "name", "status"];

export default function LogisticsCategory() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", categoryListEndpoint);
      const result = response.dynamic_page_categories;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (dynamicpagecategory_id) => {
    const payload = { dynamicpagecategory_id };
    try {
      const response = await ApiRequest("POST", categoryDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: 'Logistic Management',
    user: 'Admin',
    innerpage: 'Logistic Management / Category'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}> Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          setModalShow={setModalEditShow}
          setId={setCatId}
        // onDelete={handleDelete}
        />
      </div>
      <AddCategory show={modalShow} onHide={() => setModalShow(false)} />
      <EditCategory show={modaleditShow} catId={catId} onHide={() => setModalEditShow(false)} />
    </>
  );
}



